import React from 'react';
import Registration from './Registration';

export default () => <Registration tab="company" />;
